import api from './api';

const BASE = '/api/v1/appointment-types';

export const listAppointmentTypes = () =>
  api.get(BASE).then((r) => r.data.data.appointmentTypes);

export const createAppointmentType = (data) =>
  api.post(BASE, data).then((r) => r.data.data.appointmentType);

export const updateAppointmentType = ({ id, ...data }) =>
  api.put(`${BASE}/${id}`, data).then((r) => r.data.data.appointmentType);

export const deleteAppointmentType = (id) =>
  api.delete(`${BASE}/${id}`).then((r) => r.data);
